export const normalizeParameterKey = (value: string): string =>
  (value || "").toLowerCase().trim().replace(/\s+/g, "_");

export const createNamespacedKey = (
  groupName: string,
  parameterKey: string,
): string =>
  `${normalizeParameterKey(groupName)}_${normalizeParameterKey(parameterKey)}`;
